import { logger } from '@/lib/logger';
import {
  getTimezoneAbbreviation,
  getTimezoneLabel,
} from '@/lib/scheduling/timezone';

interface TimezoneValueLabelProps {
  value: string;
  fontSize?: 'xs' | 'table' | 'sm' | 'base' | 'lg';
  className?: string;
  truncate?: boolean;
}

const fontSizeClasses = {
  xs: 'text-xs',
  table: 'text-[13px]',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
};

export const TimezoneValueLabel: React.FC<TimezoneValueLabelProps> = ({
  value,
  fontSize = 'sm',
  className = '',
  truncate,
}) => {
  const sizeClass = fontSizeClasses[fontSize];
  const label = getTimezoneLabel(value);

  let abbr: string;
  try {
    abbr = getTimezoneAbbreviation(value);
  } catch (error) {
    // Invalid timezone - log for data quality monitoring and fall back to value itself
    logger.warn('Invalid timezone in display component', {
      component: 'TimezoneValueLabel',
      timezone: value,
      error: error instanceof Error ? error.message : String(error),
    });
    abbr = value;
  }

  const displayText = abbr && abbr !== value ? `${label} (${abbr})` : label;
  const truncateClasses = truncate ? 'block truncate' : '';

  return (
    <span
      className={`${sizeClass} ${truncateClasses} ${className}`}
      title={value}
    >
      {displayText}
    </span>
  );
};
